import Index from './pages/Index';
import AboutUs from './pages/AboutUs';
import Services from './pages/Services';

import News from './pages/MessageCenter/Index';
import NewsForm from './pages/MessageCenter/News';
import NewsList from './pages/MessageCenter/NewsList';
import NewsDetail from './pages/MessageCenter/NewsDetail';

import CompanyDynamic from './pages/CompanyDynamic/Index';
import CompanyDynamicList from './pages/CompanyDynamic/List';
import CompanyDynamicDetail from './pages/CompanyDynamic/Detail';

import RuleManner from './pages/RuleManner/Index';
import RuleMannerDetail from './pages/RuleManner/Detail';

import Profile from './pages/Profile';
import Register from './pages/Register';

import Driver from './pages/Driver/Index';
import DriverSearch from './pages/Driver/DriverSearch';
import DriverAgreement from './pages/Driver/DriverAgreement';
import DriverOrders from './pages/Driver/DriverOrders';
import DriverComplaints from './pages/Driver/DriverComplaints';

import Shipper from './pages/Shipper/Index';
import ShipperForm from './pages/Shipper/ShipperForm';
import ShipperGoods from './pages/Shipper/ShipperGoods';
import ShipperOrders from './pages/Shipper/ShipperOrders';

import OrderDetail from './pages/OrderDetail';
import Wallet from './pages/Wallet';
import ProfileMore from './pages/ProfileMore';
import MyCars from './pages/MyCars';

import FreightInfo from './pages/FreightInfo';
import PublishFreightInfo from './pages/PublishFreightInfo';

import QuestionFeedback from './pages/QuestionFeedback';


const routerConfig = [
  { path: '/', redirect: { name: 'index' } },
  { path: '/index', name: 'index', component: Index, },
  {
    path: '/driver',
    name: 'driver',
    component: Driver,
    redirect: '/driver/search',
    children: [
      { path: 'search', name: 'driver.search', component: DriverSearch },
      { path: 'agreement', name: 'driver.agreement', component: DriverAgreement },
      { path: 'orders', name: 'driver.orders', component: DriverOrders },
      { path: 'complaints', name: 'driver.complaints', component: DriverComplaints }
    ]
  },
  {
    path: '/shipper',
    name: 'shipper',
    component: Shipper,
    redirect: '/shipper/form',
    children: [
      { path: 'form', name: 'shipper.form', component: ShipperForm },
      { path: 'goods', name: 'shipper.goods', component: ShipperGoods },
      { path: 'orders', name: 'shipper.orders', component: ShipperOrders },
      { path: 'complaints', name: 'shipper.complaints', component: DriverComplaints }
    ]
  },
  {
    path: '/about-us',
    name: 'about-us',
    component: AboutUs
  },
  {
    path: '/services',
    name: 'services',
    component: Services
  },
  {
    path: '/news',
    name: 'news',
    component: News,
    redirect: '/news/form',
    children: [
      { path: 'form', name: 'news.form', component: NewsForm },
      { path: 'list', name: 'news.list', component: NewsList },
      { path: 'detail', name: 'news.detail', component: NewsDetail }

    ]
  },
  {
    path: '/companydynamic',
    name: 'companydynamic',
    component: CompanyDynamic,
    redirect: '/companydynamic/index',
    children: [
      { path: 'list', name: 'companydynamic.list', component: CompanyDynamicList },
      { path: 'detail', name: 'companydynamic.detail', component: CompanyDynamicDetail }
    ]
  },
  {
    path: '/rulemanner',
    name: 'rulemanner',
    component: RuleManner,
    redirect: '/rulemanner/index',
    children: [
      { path: 'detail', name: 'rulemanner.detail', component: RuleMannerDetail }
    ]
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile
  },
  {
    path: '/register',
    name: 'register',
    component: Register
  },
  {
    path: '/orderDetail',
    name: 'orderDetail',
    component: OrderDetail
  },
  {
    path: '/Wallet',
    name: 'Wallet',
    component: Wallet
  },
  {
    path: '/MyCars',
    name: 'MyCars',
    component: MyCars
  },
  {
    path: '/ProfileMore',
    name: 'profileMore',
    component: ProfileMore
  },
  {
    path: '/FreightInfo',
    name: 'freightInfo',
    component: FreightInfo
  },
  {
    path: '/PublishFreightInfo',
    name: 'publishFreightInfo',
    component: PublishFreightInfo
  },
  {
    path: '/QuestionFeedback',
    name: 'questionFeedback',
    component: QuestionFeedback
  },
  {
    path: '*',
    redirect: '/'
  }
];

export default routerConfig;


// WEBPACK FOOTER //
// ./src/routerConfig.js